var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component, route }){return [_c('keep-alive',[(route.meta.isKeepAlive)?_c(Component,{key:route.name,tag:"component"}):_vm._e()],1),(!route.meta.isKeepAlive)?_c(Component,{key:route.name,tag:"component"}):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }